import { ASSETS_URL, ReviewProduct, ReviewType, VideoReview } from '../../types';
import subs from '@/static/assets/reviews/MrignayniChhotwani_Pet/subs.vtt';
import poster from '@/static/assets/reviews/MrignayniChhotwani_Pet/video.jpg';

export const MrignayniChhotwani: VideoReview = {
  type: ReviewType.Video,
  product: [ReviewProduct.Pet, ReviewProduct.All],
  reviewerName: 'Mrignayni',
  videoUrl: `${ASSETS_URL}/pet/MrignayniChhotwani_Pet.webm`,
  posterUrl: poster,
  captionsUrl: subs,
};
